import React from "react";

import { Container, Card, P, P2, H1, H2 } from "./PrivacyNoticeElements";

const PrivacyNotice = () => {
  return (
    <>
      <Container>
        <Card>
          <H1> Privacy Notice </H1>
          <P>
            At Structural Connections, we are committed to protecting the
            privacy and personal information of our clients and candidates. This
            notice explains how we collect, use, and protect your personal
            information.
          </P>

          <P>
            <H2> Collection of Personal Information: </H2>
            We collect personal information from our clients and candidates,
            which may include but is not limited to: name, address, email
            address, phone number, education history, work history, skills, and
            job preferences. This information is collected through our website,
            email, phone, or in-person conversations.
          </P>

          <P>
            <H2> Use of Personal Information: </H2>
            We use personal information to provide recruitment services to our
            clients and to match job seekers with suitable job opportunities. We
            may also use personal information for marketing purposes, including
            sending job alerts, newsletters, and promotional offers.
          </P>

          <P>
            <H2> Protection of Personal Information: </H2>
            We take appropriate measures to protect your personal information
            from unauthorised access, use, or disclosure. We have implemented
            physical, electronic, and managerial procedures to safeguard and
            secure the information we collect.
          </P>

          <P>
            <H2> Sharing of Personal Information: </H2>
            We may share your personal information with our clients in order to
            match you with job opportunities that fit your skills and
            preferences. We may also share your information with third-party
            service providers who help us provide recruitment services, such as
            background check companies and testing centres.
          </P>

          <P>
            <H2> Your Rights: </H2>
            You have the right to access, correct, or delete your personal
            information. You may also request that we limit the processing of
            your personal information or object to the processing of your
            personal information for certain purposes. To exercise any of these
            rights, please contact us at the contact information provided below.
          </P>

          <P>
            <H2> Contact Us: </H2>
            If you have any questions or concerns about our privacy notice or
            the way we collect, use, or protect your personal information,
            please contact us at:
            <P2>
              <p></p>Structural Connections
              <p></p>Address: 4th Floor, Silverstream House, 45 Fitzroy Street, Fitzrovia, London, W1T 6EB
              <p></p>Email: ray@structuralconnections.co.uk
            </P2>
          </P>
        </Card>
      </Container>
    </>
  );
};

export default PrivacyNotice;
